"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorString = void 0;
/**
 * Implementation of Error.toString() if we could add it.
 *
 * @param {Error} error
 * @returns {string}
 */
var getErrorString = function (error) {
  return "Error(name=".concat(error.name, ", message=").concat(error.message, ", stack=").concat(error.stack, ")");
};
exports.getErrorString = getErrorString;